export default "__VITE_ASSET__3339c4f0__"